export default {
    askEve: "Ask Eve",
    controlHub: "Control Hub",
    dashboard: "Dashboard",
    calendar: "Calendario",
    containers: "Container",
    activity: "Activity",
    quotes: "Preventivi",
    orders: "Ordini",
    receivers: "Partner Commerciali",
    businessPartners: "Partner Commerciali",
    shippers: "Spedizionieri",
    team: "Team",
    addressBook: "Address Book",
    settings: "Impostazioni",
    companies: "Aziende",
    documents: "Documenti",
    eveDrive: "Eve Drive",
    liveTracking: "Live Tracking",
    workflows: "Workflow",
    knowledgeBase: "Knowledge Base",
    analytics: "Analytics",
    support: "Supporto",
    logout: "Logout",
    unreadNotifications: "{{count}} notifiche non lette",
};
